import React, { useEffect, useState } from 'react';
import { api } from '../api';

export default function MonitoringBadge() {
  const [n, setN] = useState(0);
  const [sev, setSev] = useState(0);
  useEffect(() => {
    const load = () => api.get('/monitoring/unread').then((r) => { setN(r.data.unread || 0); setSev(r.data.severe || 0); }).catch(() => {});
    const clear = () => { setN(0); setSev(0); };
    load();
    const t = setInterval(load, 120000);
    window.addEventListener('bond-monitoring-read', clear);
    return () => { clearInterval(t); window.removeEventListener('bond-monitoring-read', clear); };
  }, []);
  if (!n) return null;
  return <span className={`shrink-0 min-w-5 h-5 px-1.5 rounded-full ${sev ? 'bg-[#E5484D] text-white' : 'bg-[#D4AF37] text-black'} text-[11px] font-semibold flex items-center justify-center`} data-testid="nav-monitoring-unread" title={sev ? `${sev} eventi gravi` : undefined}>{n > 99 ? '99+' : n}</span>;
}
